import { Box, Link } from "@mui/material";
import { Trans } from "react-i18next";

const navigation = [
  {
    name: "API Developpeur",
    href: "/",
  },
  {
    name: "Mentions Légales",
    href: "/legal-notice",
  },
  {
    name: "Politique de confidentialité",
    href: "/privacy-policy",
  },
  {
    name: "Conditions générales d'utilisation",
    href: "/terms-of-use",
  },
  {
    name: "Manuels d'utilisation",
    href: "/users-manuals",
  },
  {
    name: "Faq",
    href: "/",
  },
  {
    name: "Contact",
    href: "/contact",
  },
  {
    name: "Recommandation",
    href: "/refer",
  },
  {
    name: "Supression de compte",
    href: "/delete-account",
  },
];

export default function Footer() {
  return (
    <Box
      id="footer"
      component="footer"
      sx={{
        px: 3,
        py: { xs: 2, sm: 0 },
        mt: "auto",
        height: { xs: "auto", sm: "75px" },
        borderTop: "1px solid",
        borderColor: "muted.main",
      }}
    >
      <Box
        sx={(theme) => ({
          display: "flex",
          flexDirection: "column-reverse",
          justifyContent: "center",
          alignItems: "start",
          width: "100%",
          height: "100%",
          [theme.breakpoints.up("md")]: {
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row",
          },
        })}
      >
        <Box sx={{ fontSize: 12, color: "muted.dark" }}>
          <Trans>footer.copyright</Trans>
        </Box>
        <Box
          sx={(theme) => ({
            display: "flex",
            flexDirection: "column",
            ">": {
              flex: 1,
            },
            [theme.breakpoints.up("sm")]: {
              flexDirection: "row",
            },
          })}
        >
          {navigation.map(({ name, href }) => (
            <Link
              href={href}
              key={name}
              underline="none"
              sx={{
                color: "muted.dark",
                fontSize: 12,
                pl: { sm: 2 },
                pb: { xs: 2, sm: 0 },
              }}
            >
              {name}
            </Link>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
